import React from "react";

import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Group,
  Loader,
  Popover,
  ScrollArea,
  Switch,
  Table,
  Text,
} from "@mantine/core";
import { useEffect, useState } from "react";
import useStyles from "./style";

import { useSelector } from "react-redux";
import UserDetail from "../MarTab/UserDetail";
import CustomPagination from "../../../../components/Pagination/CustomPagination";
import TableLoader from "../../../../components/TableLoader";
import NotFound from "../NotFound";
import {
  IconDownload,
  IconEdit,
  IconFile,
  IconTrash,
} from "@tabler/icons-react";
import { decrypt, formatDate, formatDateWithMedTimezone } from "../../../../utils";
import HideClient from "../ClientHide";
import { IconEye } from "@tabler/icons-react";
import ClientColumn from "../ClientColumn";
import DiscontinueModal from "../../../../components/DiscontinueModal";
import { useDisclosure } from "@mantine/hooks";
import { deleteMedication } from "../../../../services/patient";
import FillMedicationModal from "../../../../components/FillMedicationModal";
import { getMar } from "../../../../services";
import { isStaff } from "../../../../http";

const MedicationListTab = ({
  userId,
  clientId,
  clientDetails,
  onEditClick,
}) => {
  const { classes } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsCopy, setRowsCopy] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(true);
  const [selectDiscontinue, setSelectDiscontinue] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);

  const { selectedClient } = useSelector((state) => state.mar);
  const { allPatients } = useSelector((state) => state.patient);
  const { loading } = useSelector((state) => state.patient);
  const [activeMedicines, setActiveMedicines] = useState([]);

  const [isActive, setIsActive] = useState(true);

  let inActiveMedicinesData = Array.isArray(rows)
    ? rows?.filter((item) => item?.discontinued === true)
    : [];

  let activeMedicinesData = Array.isArray(rows)
    ? rows.filter((item) => item?.discontinued !== true)
    : [];

  const activeInActiveMedicines = (bool) => {
    if (bool) {
      setIsActive(true);
      setActiveMedicines(activeMedicinesData);
      setCurrentPage(1);
    } else {
      setIsActive(false);
      setActiveMedicines(inActiveMedicinesData);
      setCurrentPage(1);
    }
    setActiveMedicines(isActive ? activeMedicinesData : inActiveMedicinesData);
  };

  useEffect(() => {
    if (rows && rows?.length > 0) {
      activeInActiveMedicines(isActive);
    }
  }, [rows, isActive]);

  useEffect(() => {
    const filteredData = isActive ? activeMedicinesData : inActiveMedicinesData;
    setActiveMedicines(
      filteredData.slice((currentPage - 1) * 10, currentPage * 10)
    );
  }, [currentPage, isActive, rowsCopy]);

  // useEffect(() => {
  //   // inside the client state
  //   if (clientDetails) {
  //     const selectedPatient = allPatients?.find(
  //       (p) => p?.id === clientDetails?.id
  //     );
  //     if (selectedPatient?.form3?.length > 0) {
  //       setRows(selectedPatient?.form3);
  //       setRowsCopy(selectedPatient?.form3 || []);
  //       return () => {
  //         setRows([]);
  //         setRowsCopy([]);
  //       };
  //     }
  //     // from medication page
  //   } else {
  //     if (allPatients && allPatients?.length > 0) {
  //       const selectedPatient = allPatients?.find((p) => p?.id === clientId);
  //       if (selectedPatient) {
  //         setRows(selectedPatient?.form3);
  //         setRowsCopy(selectedPatient?.form3 || []);
  //         return () => {
  //           setRows([]);
  //           setRowsCopy([]);
  //         };
  //       }
  //     }
  //   }
  // }, [selectedClient, clientDetails, allPatients]);

  useEffect(() => {
    if (selectedClient?.form3?.length > 0) {
      setRows(selectedClient.form3);
      setRowsCopy(selectedClient.form3);
    } else {
      setRows([]);
      setRowsCopy([]);
    }
  }, [selectedClient]);

  console.log("🚀 ~ useEffect ~ selectedClient:", selectedClient);

  return (
    <div className={classes.content}>
      {/* <div className={classes.detailBar}>
        <div className={classes.tabContainer}></div>
        <div className={classes.userDetail}>
          <div className="detail_box">
            <div
              className="image_box"
              style={{
                backgroundImage: `url(${decrypt(selectedClient?.imageurl)})`,
              }}
              // style={{
              //   backgroundImage: `url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREoRGyXmHy_6aIgXYqWHdOT3KjfmnuSyxypw&s)`,
              // }}
            />
            <h3>{selectedClient?.name}</h3>
            <p>{selectedClient?.id?.slice(0, 6)?.toUpperCase()}</p>
          </div>
        </div>
      </div> */}
      <Box className={classes.activeInactiveParent}>
        <Button
          variant="danger"
          className={`${classes.btnCommonCSS} ${classes.activeButton} ${
            isActive && classes.activeBg
          }`}
          onClick={() => activeInActiveMedicines(true)}
        >
          <p>Active</p>
        </Button>
        <Button
          id="medication-today"
          variant="danger"
          className={`${classes.btnCommonCSS} ${classes.inActiveButton} ${
            !isActive && classes.activeBg
          }`}
          onClick={() => activeInActiveMedicines(false)}
        >
          <p>Inactive</p>
        </Button>
      </Box>
      {!userId ? (
        <HideClient show={show} setShow={setShow} />
      ) : (
        <Box m={20}></Box>
      )}
      <div className={classes.scheduleDetail}>
        {show ? (
          <>{!userId && <UserDetail isClient={false} />}</>
        ) : !loading ? (
          <ClientColumn />
        ) : (
          <></>
        )}

        <div style={{ width: userId ? "100%" : "100%", overflowX: "auto" }}>
          <div className={classes.wrapper}>
            {loading ? (
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "100px 0 0 0",
                }}
              >
                <Loader color="yellow" size={"md"} />
              </Box>
            ) : (
              <div className={classes.mainContainer}>
                <ScrollArea
                  onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                  sx={{ minHeight: "350px" }}
                >
                  <Table
                    withColumnBorders
                    withBorder
                    highlightOnHover
                    enablestickyheader
                    sx={{ fontFamily: "Inter", minWidth: "2000px" }}
                    fontSize={"sm"}
                    verticalSpacing={"md"}
                  >
                    <TableHeader scrolled={scrolled} />
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={1000}>
                            <TableLoader />
                          </td>
                        </tr>
                      ) : activeMedicines?.length > 0 ? (
                        <TableRow
                          data={activeMedicines}
                          open={open}
                          clientId={clientId}
                          onEditClick={onEditClick}
                          setSelectDiscontinue={setSelectDiscontinue}
                        />
                      ) : (
                        <NotFound />
                      )}
                    </tbody>
                  </Table>
                </ScrollArea>
                <Flex justify={"flex-end"}>
                  <CustomPagination
                    data={
                      isActive
                        ? activeMedicinesData?.length
                        : inActiveMedicinesData?.length
                    }
                    itemsPerPage={10}
                    currentPage={currentPage}
                    handlePageChange={(page) => {
                      setCurrentPage(page);
                    }}
                  />
                </Flex>
                <DiscontinueModal
                  opened={opened}
                  onclose={() => close()}
                  data={selectDiscontinue}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const TableHeader = ({ scrolled }) => {
  const { classes, cx } = useStyles();
  const { profile } = useSelector((state) => state?.profile);
  return (
    <thead
      className={cx(classes.header, {
        [classes.scrolled]: scrolled,
      })}
    >
      <tr>
        <th className={classes.stickyColumn} style={{ minWidth: "80px" }}>
          Medication Name
        </th>
        <th style={{ minWidth: "80px" }}>Prescription</th>
        <th style={{ minWidth: "80px" }}>Dosage Amount</th>
        <th style={{ minWidth: "80px" }}>Dosage Unit</th>
        <th style={{ minWidth: "80px" }}>Frequency</th>
        <th style={{ minWidth: "80px" }}>Medication Type</th>
        <th style={{ minWidth: "80px" }}>Start Date</th>
        <th style={{ minWidth: "80px" }}>Expiration Date</th>
        <th style={{ minWidth: "80px" }}>Narcotic</th>
        <th style={{ minWidth: "80px" }}>Medication Route</th>
        <th style={{ minWidth: "80px" }}>Dosage Form</th>
        <th style={{ minWidth: "80px" }}>Current Count</th>
        <th style={{ minWidth: "80px" }}>Total Quantity</th>
        <th style={{ minWidth: "80px" }}>Discontinued Date</th>
        {!isStaff(profile?.user?.role) ? (
          <th style={{ minWidth: "80px" }}>Active</th>
        ) : null}
        <th style={{ minWidth: "80px" }}>Actions</th>
      </tr>
    </thead>
  );
};

const TableRow = ({
  data,
  onEditClick,
  setSelectDiscontinue,
  open,
  clientId,
}) => {
  const { classes } = useStyles();
  const [statusId, setStatusId] = useState("");
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  // const businessTimezone = profile?.business?.timezone || "UTC";

  const _handleMedicationStatus = async (id) => {
    setStatusId(id);
    // await updateMarStatus({ id }); // api not created yet
    setStatusId("");
  };

  const downloadFile = async (url) => {
    try {
      if (url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const filename = url?.split("/")?.pop();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } else {
        console.error("No url found");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const DeleteComponent = ({ id, name, onPressOk }) => {
    const { addPatientLoading } = useSelector((state) => state?.patient);
    const [deleteModal, setDeleteModal] = useState(false);

    return (
      <Popover
        opened={deleteModal}
        width={300}
        position="top"
        withArrow
        shadow="md"
      >
        <Popover.Target>
          <ActionIcon
            color="red"
            variant="light"
            onClick={() => setDeleteModal(true)}
            title="Delete"
          >
            <IconTrash id="icon-trash" />
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown>
          <Text size="sm">
            Deleting Medication will result in also deleting the MAR
            past,present and future entries. Please confirm
          </Text>

          <Group grow mt={10}>
            <Button
              onClick={() => setDeleteModal(false)}
              size={"xs"}
              color="yellow"
            >
              Cancel
            </Button>
            <Button
              id="confirm-delete"
              loading={addPatientLoading}
              size={"xs"}
              color={"red"}
              onClick={() => onPressOk(id, name)}
            >
              Delete
            </Button>
          </Group>
        </Popover.Dropdown>
      </Popover>
    );
  };

  const remove = async (medicationId, name) => {
    await deleteMedication({
      clientId,
      medicationId,
      medicationName: name,
    });

    await getMar(localStorage.getItem("calendar_date"), clientId);
    // const data = await getSinglePatients(id);
    // setClientDetails(data);
  };

  return (
    <>
      {data?.map((row, i) => {
        const bg = i % 2 === 0;

        const isDiscontinued = "discontinued" in row;

        return (
          <tr
            key={i}
            className={
              isDiscontinued ? classes.bgDis : bg ? classes.bg2 : classes.bg1
            }
          >
            <td className={classes.stickyColumn}>
              {row?.medicationName || "-"}
            </td>
            <td style={{ color: row?.isPrescribed ? "#F00" : "black" }}>
              {row?.isPrescribed || "No"}
            </td>
            <td>{row?.dosage || "-"}</td>
            <td>{row?.unit || "-"}</td>
            <td>{row?.frequency || "-"}</td>
            <td>{row?.medicationType || "-"}</td>
            <td>
              {row?.medicationDate ? formatDate(row?.medicationDate) : "-"}
              {/* {row?.medicationDate ? formatDateWithMedTimezone(row?.medicationDate, row?.timezone) : "-"} */}
            </td>
            <td>
              {row?.expirationDate === "null"
                ? "-"
                : formatDate(row?.expirationDate)}
                {/* : formatDateWithMedTimezone(row?.expirationDate, row?.timezone)} */}
            </td>
            {/* <td>
              {row?.hasExpiryDate == "false"
                ? "-"
                : row?.medicationEndDate
                ? formatDate(row?.medicationEndDate)
                : ""}
            </td> */}
            <td style={{ color: row?.isNarcotic ? "#F00" : "black" }}>
              {row?.isNarcotic || "No"}
            </td>
            <td>{row?.ingestionMode || "-"}</td>
            <td>{row?.dosageForm || "-"}</td>
            <td style={{ textTransform: "capitalize" }}>
              {row?.medicineRemaining || "0"}
            </td>
            <td style={{ textTransform: "capitalize" }}>
              {row?.totalMedicine || "-"}
            </td>

            <td>
              {/* {"-"} */}
              {row?.discontinuedOn ? formatDate(row?.discontinuedOn) : "-"}
              {/* {row?.discontinuedOn ? formatDateWithMedTimezone(row?.discontinuedOn, row?.timezone) : "-"} */}
            </td>

            {!isStaff(profile?.user?.role) ? (
              <td>
                {row?.id === statusId ? (
                  <Loader color="black" size="xs" />
                ) : (
                  <Switch
                    size="md"
                    color="yellow"
                    disabled={isDiscontinued ? row?.discontinued : false}
                    checked={isDiscontinued ? !row?.discontinued : true}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setSelectDiscontinue(row);
                        open();
                      }
                    }}
                  />
                )}
              </td>
            ) : null}

            <td>
              <div style={{ display: "flex", gap: "10px" }}>
                {/* preview  */}
                <ActionIcon
                  id="preview"
                  color="yellow"
                  variant="light"
                  onClick={() => {
                    onEditClick(row, true);
                  }}
                  title="Preview"
                >
                  <IconEye />
                </ActionIcon>
                {!isDiscontinued && !isStaff(profile?.user?.role) && (
                  <ActionIcon
                    id="edit"
                    color="yellow"
                    variant="light"
                    onClick={(e) => {
                      onEditClick(row, false);
                    }}
                    title="Edit"
                  >
                    <IconEdit />
                  </ActionIcon>
                )}
                {/* {row?.medicineRemaining || row?.totalMedicine ? ( */}
                {!isDiscontinued &&
                  !isStaff(profile?.user?.role) &&
                  !row?.discontinueNote &&
                  row?.medicineRemaining !== "unlimited" &&
                  row?.totalMedicine !== "unlimited" && (
                    <FillMedicationModal data={row} clientId={clientId} />
                  )}
                {isDiscontinued && row?.discontinueNote && (
                  <ActionIcon
                    color="yellow"
                    variant="light"
                    onClick={(e) => {
                      downloadFile(row?.discontinueNote);
                      // window.open(row?.discontinueNote, "_blank");
                    }}
                    title="Download File"
                  >
                    <IconFile />
                  </ActionIcon>
                )}
                {row?.doctorNote && !isStaff(profile?.user?.role) && (
                  <ActionIcon
                    color="yellow"
                    variant="light"
                    onClick={(e) => {
                      downloadFile(row?.doctorNote);
                    }}
                    title="Doctor's Note"
                  >
                    <IconDownload />
                  </ActionIcon>
                )}
                {!isStaff(profile?.user?.role) ? (
                  <DeleteComponent
                    id={row?.id}
                    name={row?.medicationName}
                    onPressOk={remove}
                  />
                ) : null}
              </div>
            </td>
          </tr>
        );
      })}
    </>
  );
};

export default MedicationListTab;
